module.exports = __webpack_public_path__ + "img/item1-2.f3debcca.png";